import { useProjectPermissions } from 'hooks/useProjectPermissions'
import Checkbox from 'ui/components/forms/Checkbox'
import LinkPreview from 'ui/components/LinkPreview'
import { PublishedFields, LinkStyled, TextStyled } from './styled'

const GanttLink = ({ link, checked }) => {
  const { isManagerOrAdmin } = useProjectPermissions()

  return (
    <LinkStyled>
      <PublishedFields>
        <LinkPreview link={link} />
        {isManagerOrAdmin && (
          <Checkbox
            label="План доступен по паролю"
            name="isProtected"
            checked={checked}
            disabled
          />
        )}
      </PublishedFields>
      {!isManagerOrAdmin && checked && (
        <TextStyled>
          План-график защищён паролем. За доступом обратитесь к Руководителю
          проекта
        </TextStyled>
      )}
    </LinkStyled>
  )
}

export default GanttLink
